module.exports = __webpack_public_path__ + "static/media/manageMySpaceGreen.78441f09.svg";